import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, LoadingController, ToastController, ActionSheetController } from 'ionic-angular';
import { BasePage, iLogs } from '../../models/basePage';
import { API } from '../../services/api/api.services';
import { pouchdb } from '../../services/pouchdb/pouchdb.service';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-registro-logs',
  templateUrl: 'registro-logs.html',
})
export class RegistroLogsPage extends BasePage {

  // #region Propiedades del controlador
  public registros: Array<iLogs> = [];
  public registroActual: iLogs = undefined;

  // #endregion

  constructor(public navCtrl: NavController, public navParams: NavParams, public platform: Platform, public loadingCtrl: LoadingController, public http: Http, toastCtrl: ToastController, public DBService: pouchdb.DBService, SessionService: API.SessionService, public actionSheetCtrl: ActionSheetController, public DesignacionesService: API.DesignacionesService) {
    super(navCtrl, platform, http, toastCtrl, DBService, loadingCtrl);

    // Obtención de la lista de LOGS guardados en la aplicación
    DBService.ObtenerLogs()
      .then((resultado: Array<iLogs>) => {
        this.registros = resultado;

        this.GuardarLog("", "RegistroLogsPage", "constructor", "Lista de registros LOGS obtenida.");
      })
      .catch(error => this.Error(JSON.stringify(error), "RegistroLogsPage", "constructor", "Obteniendo la lista de registros LOGS."));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegistroLogsPage');
  }

  public EliminaTodosLosRegistros(): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Eliminar todos los registros',
      buttons: [
        {
          text: 'Confirmar',
          handler: () => {
            this.MostrarCarga();
            this.DBService.EliminarTodosLogs()
              .then((resultado: boolean) => {
                this.registros = [];
                this.OcultarCarga();
              })
              .catch((error) => this.Error(JSON.stringify(error), "registro-logs", "EliminarTodosLosRegistros", "ERROR: No se ha podido eliminar todos los registros de LOGS de la BD."));
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public EstablecerRegistro(registro: iLogs): void {
    this.registroActual = registro;
  }

  public GuardarIncidencias(): void {
    if (this.registros != null && this.registros.length > 0) {
      this.MostrarCarga();
      this.DesignacionesService.registroIncidencias(this.registros, 0, this.designacion.urlApi)
        .then((resultado: boolean) => {
          if (resultado) {
            this.Mensaje("Se ha realizado correctamente el guardado de las incidencias en el servidor.", "", 4000);
          }
          else {
            this.Mensaje("No se ha realizado el guardado correctamente.", "", 4000);
          }
          this.OcultarCarga();
        })
        .catch(error => this.Error(JSON.stringify(error), "registro-logs", "GuardarIncidencias", "Enviando la lista de registro de incidencias al servidor"));
    }
    else {
      this.Mensaje("No hay incidencias que guardar.", "", 4000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/registro-logs/registro-logs.ts